import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Signup.css'; // External CSS file for styling
import { useLocation } from 'react-router-dom';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [referralCode, setReferralCode] = useState('');
  const location =useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search); // Parse the URL query string
    const referral = queryParams.get('referralCode'); // Get the referralCode parameter
    console.log(referral);
    if (referral) {
      setReferralCode(referral); // Set the referral code state
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }
    setLoading(true);
    setError(''); // Reset error message

    try {
      // Send POST request to server
      // console.log("signup",referralCode)
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/signup`, {
        name,
        email,
        password,
        referralCode
      });
      console.log(response.data);
      setError(response?.data);
      // Assuming server returns the user data (excluding password)
      if (response.status == 200) {
        // Optionally, you can store a token or user ID here for authentication
        // localStorage.setItem('userId', response.data.user._id); // Store the user ID or other details
        // Redirect to a different page or show a success message
        console.log('Signup successful');
        // You could also redirect the user to the signin page or home page:        
        window.location.href = '/signin'; // Redirect to signin page
      }
    } catch (err) {
      // Handle error if the server responds with an error
      setError(err.response?.data || 'An error occurred');
    } finally {
      setLoading(false); // Stop loading indicator after the request is complete
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-form">
        <h2>Create an Account</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="Please enter your full name"
            />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Please enter your email"
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Please enter your password"
            />
          </div>
          <div className="input-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Confirm your password"
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
        </form>
        <p className="signin-link">
          Already have an account? <a href="/signin">Sign In</a>
        </p>
      </div>
    </div>
  );
};

export default Signup;
